import { TiptapDisplayInteractive } from "@skyltmax/ds9"
import { YoutubeVideo } from "@skyltmax/ds9/tiptap"
import { type JSONContent } from "@tiptap/core"
import React from "react"
import siteStack from "@/common/tiptap_stack"

export const signtagExtensions = [...siteStack, YoutubeVideo]

interface SignsTagContentProps {
  content: JSONContent
  className?: string
}

const SignsTagContent: React.FC<SignsTagContentProps> = ({ content, className }) => {
  return <TiptapDisplayInteractive fragment extensions={signtagExtensions} json={content} className={className} />
}

export default SignsTagContent
